import PropTypes from 'prop-types';

import AttachFileIcon from '@mui/icons-material/AttachFile';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import CustomBox from '../common/CustomBox';

const PatientFileItem = props => {
  const {patientFile: f} = props;
  return (
    <CustomBox>
      <Stack
        direction='row'
        padding={1}
        spacing={1}
        alignItems='center'
        justifyContent='space-between'
      >
        <AttachFileIcon />
        <Typography variant='body'>
          {f.title}
        </Typography>
        <IconButton
          variant='contained'
          color='primary'
          disabled={!f.url}
          href={f.url}
          target='_blank'
        >
          <DownloadIcon/>
        </IconButton>
      </Stack>
    </CustomBox>
  );
};

PatientFileItem.propTypes = {
  patientFile: PropTypes.object.isRequired,
};

export default PatientFileItem;
